import { defs } from './registry';

/**
 * Canonical hand order: low Ascension tiers always read left-to-right. JavaScript's stable sort
 * preserves the player's chosen order inside each tier. Unknown ids remain last for validation.
 */
export function orderDeckByAscension(cards: readonly string[]): string[] {
  return cards
    .map((cardId, index) => ({ cardId, index, ascension: defs.cards.get(cardId)?.ascension ?? 99 }))
    .sort((a, b) => a.ascension - b.ascension || a.index - b.index)
    .map(({ cardId }) => cardId);
}
